var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEthereum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79891 0.831055L6.65625 1.31563V15.3756L6.79891 15.5179L13.3252 11.6601L6.79891 0.831055Z",
    fill: "#BCC9F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80092 0.831055L0.274414 11.6601L6.80092 15.5179V8.69359V0.831055Z",
    fill: "#F8F8F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79915 16.7523L6.71875 16.8503V21.8587L6.79915 22.0934L13.3295 12.8965L6.79915 16.7523Z",
    fill: "#BCC9F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80092 22.0934V16.7523L0.274414 12.8965L6.80092 22.0934Z",
    fill: "#F6F7F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79883 15.5186L13.3252 11.6609L6.79883 8.69434V15.5186Z",
    fill: "#7894EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.274414 11.6609L6.80092 15.5186V8.69434L0.274414 11.6609Z",
    fill: "#BCC9F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEthereum);
export default __webpack_public_path__ + "static/media/icon-ethereum.3e395275cb2c5f10bbcbef2f663f9e7f.svg";
export { ForwardRef as ReactComponent };